import React, { Fragment } from "react";

const WeOffer = (weOfferInfo) => {
  console.log({ weOfferInfo });
  return (
    <Fragment>
      {" "}
      <div className="sale-w3ls">
        <div className="container">
          <h6>
            We Offer Flat <span>40%</span> Discount
          </h6>

          <a className="hvr-outline-out button2" href="single.html">
            Shop Now
          </a>
        </div>
      </div>
    </Fragment>
  );
};

export default WeOffer;
